import { api, LifeSkillsLevel } from 'api';
import { rtkQueryApi } from 'store/rtkQueryApi';

const lifeSkillsMonitoringDictionariesApi = rtkQueryApi.injectEndpoints({
  endpoints: (builder) => ({
    lifeSkillsLevelsForExaminer: builder.query<
      LifeSkillsLevel[],
      { examinerId: number; checkStatus?: boolean }
    >({
      query: ({ examinerId, checkStatus = false }) => {
        return api.lifeSkillsLevel.getLevelsForExaminer({ examinerId, checkStatus });
      },
    }),
  }),
});

export const { useLifeSkillsLevelsForExaminerQuery } = lifeSkillsMonitoringDictionariesApi;
